module.exports = __webpack_public_path__ + "img/pic-goal.db6f631.webp";